export enum ContentStatus {
	CURRENT = 'current',
	DRAFT = 'draft',
	ARCHIVED = 'archived',
}
